import { Link } from 'react-aria-components';
import styled from 'styled-components';

export const Selector = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 38px;
  height: 301px;
  background: var(--brand-500);
  border: none;
  border-radius:  0 var(--radius-large) var(--radius-large) 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  text-decoration: none;

  &[data-focus-visible] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
    outline: 0;
  }

  & span {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-bold);
    line-height: 23px;
    color: var(--black);
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    white-space: nowrap;
  }

  & svg {
    width: 23px;
    height: 23px;
  }

  @media (width >= 58rem) {
    width: 62px;
    height: 753px;
    border-radius: var(--radius-large) 0 0 var(--radius-large);

    & span {
      font-size: var(--font-size-display-xs);
      line-height: 28px;
    }

    & svg {
      width: 28px;
      height: 28px;
    }
  }
`;
